import ButtonV2 from './ButtonV2'

export default ButtonV2
